var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Slider,_vm._b({attrs:{"auto-play":_vm.autoPlay,"photo-swipe":true,"data":_setup.props.images}},'Slider',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }